// extracted by mini-css-extract-plugin
export var table = "_xf-0";